import TimePicker, { type TimePickerProps } from './index';
import { dateToHHmm, hhmmToLocalDate } from 'utils/timePickerBridge';

export interface DateBoundTimePickerProps
  extends Omit<TimePickerProps, 'value' | 'onChange'> {
  value: Date | null | undefined;
  onChange: (next: Date | null) => void;
}

/**
 * 기존 MUI `MobileTimePicker`처럼 `Date | null`만 다루고, 내부는 커스텀 `TimePicker`(HH:mm)만 사용.
 * 데이터/API 스펙은 호출부가 그대로 `Date | null`을 유지.
 */
export function DateBoundTimePicker({
  value,
  onChange,
  ...rest
}: DateBoundTimePickerProps) {
  return (
    <TimePicker
      value={dateToHHmm(value)}
      onChange={t => onChange(hhmmToLocalDate(t, value))}
      {...rest}
    />
  );
}

export default DateBoundTimePicker;
